module.exports = __webpack_public_path__ + "static/media/oxen.48dfe193.png";